import { createGrid, themeQuartz } from 'ag-grid-community'
import { analyseIntercoTransactions } from '../analyse-interco-transactions/index.js'
import { makeColDefs } from './col-defs/index.js'
import { makeRows } from './rows/index.js'

let gridApi
const containerId = 'viewGrid'

export function showAgGridV2 (context) {
  console.log('showAgGridV2', context)

  const intercoTransactionsAnalysis = analyseIntercoTransactions(context.groupTransactions, {
    currenciesRates: context.currenciesRates,
    entities: context.browserAppAccount.data.entities,
    shownCurrencyCode: context.menuOptions.optionCurrency.selectedOption().value,
    dateGroupingMethod: context.menuOptions.optionGrouping.selectedOption().value
  })

  const gridDefs = {
    rows: makeRows(intercoTransactionsAnalysis, context),
    columnDefs: makeColDefs(context)
  }
  console.log('gridDefs', gridDefs)

  const gridContainerElement = document.getElementById(containerId)
  console.log('gridContainerElement', gridContainerElement)

  if (gridApi && gridContainerElement) {
    updateGrid(gridApi, gridDefs)
  } else {
    gridApi = createAgGrid(gridDefs, context, gridContainerElement)
  }

  return gridApi
}

function updateGrid (gridApi, gridDefs) {
  gridApi.updateGridOptions({
    rowData: gridDefs.rows,
    columnDefs: gridDefs.columnDefs
  })
}

function createAgGrid (gridDefs, context, gridContainerElement) {
  const gridOptions = {
    // pinnedTopRowData: [{ row: 'linkToXero' }],
    rowData: gridDefs.rows,
    columnDefs: gridDefs.columnDefs,
    defaultColDef: {
      filter: true,
      floatingFilter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true
    },
    context,
    theme: themeQuartz,
    overlayNoRowsTemplate: 'No transactions matching',
    // autoSizeStrategy: {
    //   type: 'fitCellContents'
    // },
    onCellClicked: function (cellParams) {
      console.log('onCellClicked', cellParams)
    },
    getRowId: (cellParams) => cellParams.data.rowId,
    getRowHeight: function (cellParams) {
      if (Number.isInteger(cellParams.data.rowHeight)) {
        return cellParams.data.rowHeight
      }
      if (cellParams.data.type === 'break') {
        return 10
      }
    }
  }
  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('grid created', gridApi)

  return gridApi
}
